// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_uv-8";
export var editMode = "_uv-3";
export var headerRow = "_uv-a";
export var headerTitle = "_uv-b";
export var product = "_uv-1";
export var productDetails = "_uv-5";
export var productDivider = "_uv-7";
export var productImage = "_uv-2";
export var productInfo = "_uv-4";
export var productTitle = "_uv-6";
export var strikethrough = "_uv-9";
export var upsellProductsCard = "_uv-0";